import { intersection } from 'lodash';
import { useLocation } from 'react-router-dom';

export function useIsShop() {
  const { pathname } = useLocation();

  return !!intersection(pathname.split('/'), ['shop-new']).length;
}
